import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal'

/* Icons */
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function Modal({
    open,
    handleClose,
    closeText = trans(`app.modal.close`),
    modalBody = null,
    modalTitle = '',
    className,
    modalContent = (
        <>
            <BootstrapModal.Header className="d-flex justify-content-between align-items-center">
                <p className="font-weight-medium mb-0">{modalTitle}</p>
                <Button
                    className="p-0"
                    theme="none"
                    showTitle={false}
                    title={closeText}
                    showIcon={true}
                    icon={CrossIcon}
                    iconSize={12}
                    iconClassName={'icon--lg-16'}
                    onClick={handleClose}
                />
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                {modalBody}
            </BootstrapModal.Body>
        </>
    )
}) {
    return (
        <BootstrapModal
            centered
            show={open}
            onHide={handleClose}
            className={className}
        >
            {modalContent}
        </BootstrapModal>
    );
}
